// Global Instructions Rule Applied!
//
// Shared color vocabulary for agent state cards (company + deal strips).
// Condition colors map cfg rank BANDS (lower = worse), never hardcoded keys —
// the catalogue is cfg data and can grow without touching this file. The Tag
// keeps the AntD color-name vocabulary; the card's 4px left border (the
// AgentSignalCard idiom) uses the matching hex.

// Rank-band → AntD Tag color (rank: lower = worse; null = unknown/off-scale).
export const conditionColor = (rank: number | null | undefined): string => {
  if (rank == null) return 'default'
  if (rank <= 0) return 'volcano'
  if (rank <= 10) return 'red'
  if (rank <= 20) return 'gold'
  if (rank <= 30) return 'green'
  return 'cyan'
}

export const kindColor = (kind: string): string =>
  kind === 'transitory' ? 'blue' : kind === 'ask' ? 'purple' : 'default'

// Card left-border hex per rank band (mirrors conditionColor's bands with the
// AntD palette hexes; default = neutral gray for unknown/off-scale).
export const conditionBorderColor = (rank: number | null | undefined): string => {
  if (rank == null) return '#d9d9d9'
  if (rank <= 0) return '#fa541c'
  if (rank <= 10) return '#f5222d'
  if (rank <= 20) return '#faad14'
  if (rank <= 30) return '#52c41a'
  return '#13c2c2'
}

// Brand primary for transitory (matches the design-system primary #4C90E9),
// AntD purple for asks.
export const kindBorderColor = (kind: string): string =>
  kind === 'transitory' ? '#4C90E9' : kind === 'ask' ? '#722ed1' : '#d9d9d9'
